module.exports = __webpack_public_path__ + "static/rmi-56bf25ae1a6be6798458701a442ad9da.png";